// src/components/common/GiveUpButton.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@/icons';
import './GiveUpButton.css';

interface GiveUpButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

const GiveUpButton: React.FC<GiveUpButtonProps> = ({
  onClick,
  disabled = false,
  className = '',
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`give-up-button ${className}`}
    >
      <FontAwesomeIcon icon={faBan} /> Desistir
    </button>
  );
};

export default GiveUpButton;
